import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {FormBuilder, FormControl, Validators, FormGroup} from '@angular/forms';
import {HttpClient} from '@angular/common/http';
import {ActivatedRoute, Router} from '@angular/router';

import {Store} from '@ngrx/store';
import {AuthService, ConfigService, StorageService} from '@cosbeni/auth';
import {FormHelperService} from '../services/form-helper.service';
import {ToasterService} from 'angular2-toaster';
import {TranslocoService} from '@jsverse/transloco';

import {ActivePromotionConfig} from '../config/active-promotion.config';
import {DataService} from '@cosbeni/database';
import {PasswordValidators} from '../services/password.validators';

declare let jQuery: any;

@Component({
    standalone: false,
    selector: 'app-dashboard',
    styleUrls: ['change-password.component.css'],
    templateUrl: 'change-password.component.html',
    encapsulation: ViewEncapsulation.None
})
export class ChangePasswordComponent implements OnInit {
    /** サーバ (PasswordResetService) と揃える */
    static readonly MIN_PASSWORD_LENGTH = 8;

    changed: boolean = false;
    /** リンクが無効・期限切れのときに出す案内 */
    expired: boolean = false;

    account: any = {password: ''};
    form: FormGroup;
    token: string = '';

    constructor(public store: Store<any>, public router: Router, public formHelper: FormHelperService, public formBuilder: FormBuilder, public auth: AuthService, public dataService: DataService, public config: ConfigService, public storage: StorageService, public toasterService: ToasterService, public route: ActivatedRoute, public http: HttpClient, private transloco: TranslocoService) {
    }

    ngOnInit() {
        this.route.queryParams
            .subscribe(params => {
                    this.token = params.token;
                }
            );
        this.form = this.formBuilder.group({
            password: new FormGroup({
                newPassword: new FormControl('', [Validators.required, Validators.minLength(ChangePasswordComponent.MIN_PASSWORD_LENGTH)]),
                confirmPassword: new FormControl('', [])
            }, PasswordValidators.mismatchedPasswords())
        });
    }

    changePassword(value: any) {
        this.expired = false;
        this.http.post(ActivePromotionConfig.SERVER_URL + '/rest/public/promotion/password/reset', {
            token: this.token,
            password: value.password.newPassword
        }).subscribe(() => {
                this.changed = true;
                this.toasterService.pop('info', this.transloco.translate('shell.change'), this.transloco.translate('shell.password_changed_toast'));
            },
            err => {
                // 400 はリンクが無効 / 期限切れ / 使用済み、それ以外はサーバ側の問題
                if (err && err.status == 400) {
                    this.expired = true;
                    this.toasterService.pop('error', this.transloco.translate('shell.change'), this.transloco.translate('shell.link_expired_toast'));
                } else {
                    this.toasterService.pop('error', this.transloco.translate('shell.change'), this.transloco.translate('shell.password_change_failed'));
                }
            },
        );
    }

}
